<template>
  <div>
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <App-Tabela
      :cpntSetarFiltros="cpntSetarFiltros"
      :cpntMontarFiltros="cpntMontarFiltros"
      :cpntMontarWhere="vendaRelatorioUltimaVenTabTabelaMontarWhere"
      :cpntColuna="colunas"
      :cpntLinha="linha"
      :cpntMostrarMper="true"
      :cpntBotaoExportar="exportar"
      :cpntSetarValores="vendaRelatorioUltimaVenTabSetarLinhas"
      :cpntApiTabPer="tabper"
      :cpntApiTabPerOrder="tabPerOrder"
      :cpntApiRouter="route"
      :cpntApiGroup="group"
      :cpntApiWhere="where"
      :cpntApiMethods="'POST'"
      :cpntApiEstruturaQueryGet="estruturaQueryGet"
      @cpntSetarStatusLiberado="vendaRelatorioUltimaVenTabSetarStatusLiberado"
      ref="tabela">
        <!-- COLUNA DE INFORMAÇÕES -->
        <template v-slot:col_id_con="{ linha }">
          <App-Button v-if="linha.link_cadastro_con !== null"
            :cpntStatus='linha.link_cadastro_con.status' 
            :cpntClass='linha.link_cadastro_con.class'
            @onClick='() => { vendaRelatorioUltimaVenTabOnClick("id_con", linha) }'>
            <!-- COLOCA O NOME DO CONTATO -->
            <span v-html="linha.id_con_nome"></span>

            <!-- VERIFICA SE É UMA PJ E SE TEM NOME FANTASIA -->
            <span v-if='linha.id_con_pessoa === "j" && linha.id_con_empresa !== ""' v-html="' (' + linha.id_con_empresa + ')'"></span>

            <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
            <b v-if='linha.id_con_status !== "1"' v-html="'[Excluído]'"></b>
          </App-Button>

          <!-- SETA O CONTEUDO SE NÃO TIVER BOTÃO -->
          <span v-else>&nbsp;</span>
        </template>

        <!-- SETA A COLUNA TELEFONE -->
        <template v-slot:col_telefone="{ linha }">
          <div v-if="linha.id_con_pessoa === 'e'">
            <span v-html="linha.id_con_tel_cel"></span>
          </div>
          <template v-else>
            <div v-if="[ '', null, undefined ].indexOf(linha.id_con_tel_cel) === -1">
              <span v-html="linha.id_con_tel_cel"></span><span> (Cel.)</span>
            </div>
            <div v-if="[ '', null, undefined ].indexOf(linha.id_con_tel_res) === -1">
              <span v-html="linha.id_con_tel_res"></span><span> (Res.)</span>
            </div>
            <div v-if="[ '', null, undefined ].indexOf(linha.id_con_tel_com) === -1">
              <span v-html="linha.id_con_tel_com"></span><span> (Com.)</span>
            </div>
          </template>
        </template>

        <template v-slot:link="{ linha, indexCV }">
          <span>
            <div :class="[ '', null, undefined, '---' ].indexOf(linha[indexCV]) !== -1 ? '' : 'ven-rel-link'" @click="() => { vendaRelatorioUltimaVenTabOnClick(indexCV, linha) }">
              <span v-html="linha[indexCV]"></span>
            </div>
          </span>
        </template>

        <template v-slot:col_vencimento_max_ptbr="{ linha, indexCV }">
          <span>
            <div :class="[ '', null, undefined, '---' ].indexOf(linha[indexCV]) !== -1 ? '' : 'ven-rel-link'" @click="() => { vendaRelatorioUltimaVenTabOnClick(indexCV, linha) }">
              <span v-html="linha[indexCV]"></span>
            </div>

            <span style="font-size: calc(100% - 2px);" v-html="'(' + linha.ultima_venda_tempo + ')'"></span>
          </span>
        </template>
      </App-Tabela>
    </template>
  </div>
</template>

<style scoped>
  .ven-rel-link:hover {
    cursor: pointer;
    text-decoration: underline;
  }
</style>

<script>
// IMPORTA BIBLIOTECA DEPENDENTE
var moment = require('moment')

export default {
  props: {
    cpntSetarFiltros: {
      required: false,
      default: function () {
        return (callback) => { callback() }
      }
    },
    cpntMontarFiltros: {
      required: false,
      default: function () {
        return (callback) => { callback([]) }
      }
    }
  },
  data: function () {
    return {
      time: '',
      statusGeral: 'carregando',
      liberado: 'carregando',
      tabper: 'VenRelUltVenda',
      // route: '/venda/relatorio/relacionamento/get',
      route: '/venda/relatorio/ult-venda/get',
      colunas: [],
      linha: [],
      tabPerOrder: [          
        // { id: '0',  nome: 'Ordem Alfabética', chave: 'id_con_nome', order: 'asc'  },
        { id: '0',  nome: 'Última Venda Decrescente', chave: 'vencimento',    order: 'desc', operacao: 'max' },
        { id: '1',  nome: 'Última Venda Crescente',   chave: 'vencimento',    order: 'asc',  operacao: 'max' },
        { id: '2',  nome: 'Ordem Alfabética',         chave: 'id_con_nome',   order: 'asc'                    },
      ],  
      where: {},
      group: [],
      estruturaQueryGet: [
        [ 'type', 'countAll', 'limit', 'field', 'field_virtual', 'where', 'order', 'group' ]
      ],
      acessos: {
        veiculo: false,
        pet: false
      },
      exportar: {
        format: [ 'xlsx', 'pdf' ],
        search: true,
        field: [
          { id_con_nome:                             'Nome'                     },
          { vencimento_max_ptbr:                     'Última venda'             },
          { id_con_tel_cel:                          'Telefone Celular'         },
          { id_con_tel_com:                          'Telefone Comercial'       },
          { id_con_tel_res:                          'Telefone Residencial'     },
          { id_con_email:                            'E-mail'                   },
          { virtual_id_con_qtde_venda:               'Qtde de vendas'           },
          { virtual_id_con_total_venda_produto:      'Venda total produto'      },
          { virtual_id_con_total_venda_servico:      'Venda total serviço'      },
          { virtual_id_con_total_venda:              'Venda total'              },
          { virtual_id_con_ticket_medio_venda:       'Ticket médio'             }
        ]
      }
    }
  },
  mounted: function () {
    // SETA O STATUS DA PAGINA
    this.vendaRelatorioUltimaVenTabSetarStatusGeral('carregando')
    
    // MONTA OS VALORES QUE SERÁ UTILIZADO NA TABELA
    this.vendaRelatorioUltimaVenTabBuscarLinhas()
  },
  methods: {
    vendaRelatorioUltimaVenTabSetarStatusGeral: function (status) {
      // SETA O STATUS DA TELA
      this.statusGeral = status

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    vendaRelatorioUltimaVenTabSetarStatusLiberado: function (status) {
      // SETA O STATUS DA TELA
      this.liberado = (status === '' || status === true) ? '' : (status === false ? 'carregando' : status)

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    vendaRelatorioUltimaVenTabBuscarLinhas: function () {
      // VERIFICA SE TEM ACESSO AO ITEM DESEJADO
      this.acessos.pet = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 28 ], null, [ 52 ], null, null, null, false) === true
      this.acessos.veiculo = this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 8 ], null, [ 14 ], null, null, null, false) === true

      // SETA O WHERE QUE DEVE REALZIAR NA API
      this.where = { aAnd: [ { f: 'status', o: '=', v: '2' } ] }

      // SETA AS COLUNAS DA TABELA
      var colunas = [
        { mPer: 2,                chave: 'id_con',                                   nome: 'Contato',                  fieldsApi: { cod_venda: { o: 'max' }, id_con: { j: { nome: null, empresa: null, pessoa: null, status: null, tel_cel: null, tel_com: null, tel_res: null, email: null } } } },
        { mPer: 1, chave: 'telefone',              nome: 'Telefones' },       
        // { mPer: 1, slot: 'link',  chave: 'virtual_id_con_qtde_pet',                  nome: 'Qtde de Pet',              fieldsVir: [ [ 'id_con_qtde_pet' ] ] },
        // { mPer: 1, slot: 'link',  chave: 'virtual_id_con_qtde_veiculo',              nome: 'Qtde de Veículo',          fieldsVir: [ [ 'id_con_qtde_veiculo' ] ] },
        { mPer: 1,                chave: 'vencimento_max_ptbr',                          nome: 'Última venda',             fieldsApi: [ { vencimento: { o: 'max' } } ] },
        // { mPer: 1, slot: 'link',  chave: 'virtual_id_con_qtde_orcamento',            nome: 'Qtde de orçamentos',       fieldsVir: [ [ 'id_con_qtde_orcamento' ] ] },
        { mPer: 1, slot: 'link',  chave: 'virtual_id_con_qtde_venda',                nome: 'Qtde de vendas',           fieldsVir: [ [ 'id_con_qtde_venda' ] ] },
        
        // { mPer: 1,                chave: 'virtual_id_con_total_orcamento_produto',   nome: 'Orçamento total produto',  fieldsVir: [ [ 'id_con_total_orcamento_produto' ] ] },
        // { mPer: 1,                chave: 'virtual_id_con_total_orcamento_servico',   nome: 'Orçamento total serviço',  fieldsVir: [ [ 'id_con_total_orcamento_servico' ] ] },
        // { mPer: 1,                chave: 'virtual_id_con_total_orcamento',           nome: 'Orçamento Total',          fieldsVir: [ [ 'id_con_total_orcamento' ] ] },

        { mPer: 1,                chave: 'virtual_id_con_total_venda_produto',       nome: 'Venda total produto',      fieldsVir: [ [ 'id_con_total_venda_produto' ] ] },
        { mPer: 1,                chave: 'virtual_id_con_total_venda_servico',       nome: 'Venda total serviço',      fieldsVir: [ [ 'id_con_total_venda_servico' ] ] },
        { mPer: 1,                chave: 'virtual_id_con_total_venda',               nome: 'Venda total',              fieldsVir: [ [ 'id_con_total_venda' ] ] },
        { mPer: 1,                chave: 'virtual_id_con_ticket_medio_venda',        nome: 'Ticket médio',             fieldsVir: [ [ 'id_con_ticket_medio_venda' ] ] },

        // { mPer: 1, slot: 'link',  chave: 'virtual_id_con_financeiro_aberto',         nome: 'Financeiro em aberto',     fieldsVir: [ [ 'id_con_financeiro_aberto' ] ] },
        // { mPer: 1, slot: 'link',  chave: 'virtual_id_con_financeiro_atraso',         nome: 'Financeiro em atraso',     fieldsVir: [ [ 'id_con_financeiro_atraso' ] ] }
      ]

      // INCIA A VARIAVEL PARA REMOVER COLUNA
      var remover = []

      // VERIFICA SE TEM O PACOTE DE VEICULO
      if (this.acessos.pet === false) {
        remover.push('virtual_id_con_qtde_pet')
      }


      // VERIFICA SE TEM O PACOTE DE VEICULO
      if (this.acessos.veiculo === false) {
        remover = remover.concat([ 'virtual_id_con_qtde_veiculo' ])
      }

      // REMOVE AS COLUNAS QUE NÃO TEM TOTAL
      if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6, 15 ], 'and', null, null, null, null, false) === false) {
        remover = remover.concat([ 'virtual_id_con_total_orcamento_produto', 'virtual_id_con_total_orcamento_servico', 'virtual_id_con_total_venda_produto', 'virtual_id_con_total_venda_servico' ])
      }

      // REMOVE AS COLUNAS INFORMADAS
      if (remover.length >= 1) {
        colunas = colunas.filter(item => remover.indexOf(item.chave) === -1)
      }

      // SETA O GROUP QUE DEVE REALIZAR
      this.group.push([ 'id_con' ])

      // SETA AS COLUNAS MONTADAS
      this.colunas = colunas

      // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
      if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 || this.statusGeral === '') {
        this.vendaRelatorioUltimaVenTabReiniciar()
      } else {
        this.vendaRelatorioUltimaVenTabSetarStatusGeral('')
      }
    },
    vendaRelatorioUltimaVenTabReiniciar: function (tentativa = 0) {
      if (tentativa <= 5) {
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
          this.$refs.tabela.cpntTabelaReiniciar()
        } else {
          setTimeout(() => { this.vendaRelatorioUltimaVenTabReiniciar((tentativa + 1)) }, 100)
        }
      }
    },
    vendaRelatorioUltimaVenTabTabelaMontarWhere: function (where) {
      // INICIA A VARIAVEL DE RETORNO
      var retorno = {}
      
      // CONVERTE O VALOR RECEBIDO
      if (where.o === '%') {
        where.o = 'like'
      }

      // VERIFICA SE DEVE SETAR ALGUM VALOR
      switch (where.f) {
        case 'codigo':
          retorno.where = { f: 'cod_venda', o: 'in', v: where.v }
          break

        case 'status':
          retorno.where = { f: 'status', o: '=', v: (where.v === 'venda' ? '2' : '1') }
          break

        case 'vencimento':
          // VERIFICA SE TEM QUE GERAR O VALOR
          if ([ '', null, undefined ].indexOf(where.v._dataIni) !== -1) {
            where.v._dataIni = moment(where.v.dataIni, 'DD/MM/YYYY').format('YYYY-MM-DD')
          }
          if ([ '', null, undefined ].indexOf(where.v._dataFim) !== -1) {
            where.v._dataFim = moment(where.v.dataFim, 'DD/MM/YYYY').format('YYYY-MM-DD')
          }

          // SETA O WHERE QUE DEVE REALIZAR
          if (where.o === '=') {
            retorno.where = { aAnd: [
              { f: 'vencimento', o: '>=', v: where.v._dataIni + ' 00:00:00' },
              { f: 'vencimento', o: '<=', v: where.v._dataFim + ' 23:59:59' }
            ] }
          } else if (where.o === '<>') {
            retorno.where = { aOr: [
              { f: 'vencimento', o: '<', v: where.v._dataIni + ' 00:00:00' },
              { f: 'vencimento', o: '>', v: where.v._dataFim + ' 23:59:59' }
            ] }
          } else if ([ '<=' ].indexOf(where.o) !== -1) {
            retorno.where = { aOr: [
              { f: 'vencimento', o: where.o, v: where.v._dataFim + ' 23:59:59' }
            ] }
          } else if ([ '>=' ].indexOf(where.o) !== -1) {
            retorno.where = { aOr: [
              { f: 'vencimento', o: '>', v: where.v._dataIni + ' 00:00:00' }
            ] }
          }
          break

        case 'last_user':
          retorno.where = { f: 'updated_user', o: where.o, v: where.v.join(',') }
          break

        case 'id_con_nome':
          if (where.o === '=') {
            retorno.where = { f: 'id_con', o: 'in', v: where.v.join() }
          } else {
            retorno.where = Object.assign(where, { m: 'contato', f: 'nome' })
          }
          break

        case 'id_con_cnpj':
        case 'id_con_cpf':
          retorno.where = { m: 'contato', f: 'cnpj_cpf', o: where.o, v: where.v }
          break

        case 'id_con_telefone':
          retorno.where = { aOr: [
            { m: 'contato', f: 'tel_res', o: where.o, v: where.v },
            { m: 'contato', f: 'tel_com', o: where.o, v: where.v },
            { m: 'contato', f: 'tel_cel', o: where.o, v: where.v }
          ] }
          break

        case 'id_con_email':
          retorno.where = { m: 'contato', f: 'email', o: where.o, v: where.v }
          break

        case 'id_con_estado':
          retorno.where = { m: 'contato', f: 'id_estado', o: where.o, v: where.v.join(',') }
          break

        case 'id_con_cidade':
          retorno.where = { m: 'contato', f: 'id_cidade', o: where.o, v: where.v.join(',') }
          break

        case 'id_con_tp_con':
          retorno.where = { m: 'contato', f: 'id_tp_con', o: where.o, v: where.v.join(',') }
          break

        case 'id_con_pessoa':
          retorno.where = { m: 'contato', f: 'pessoa', o: where.o, v: where.v }
          break

        case 'id_pet_nome':
          if (where.o === '=') {
            retorno.where = { f: 'id_pet', o: 'in', v: where.v.join() }
          } else {
            retorno.where = Object.assign(where, { m: 'pet', f: 'nome' })
          }
          break

        case 'id_pet_sexo':
          retorno.where = { m: 'pet', f: 'sexo', o: where.o, v: (where.v === 'n' ? '' : where.v) }
          break

        case 'id_pet_especie':
          retorno.where = { m: 'pet', f: 'id_pet_subespecie', o: 'in', r: 'id', q: {
            model: 'pet_subespecie',
            where: { f: 'id_especie', o: '=', v: where.v.join() }
          } }
          break

        case 'id_pet_raca':
          retorno.where = { m: 'pet', f: 'id_pet_subespecie', o: where.o, v: where.v }
          break

        case 'id_vei_placa':
          if (where.o === '=') {
            retorno.where = { f: 'id_vei', o: 'in', v: where.v.join() }
          } else {
            retorno.where = Object.assign(where, { m: 'veiculo', f: 'placa' })
          }
          break

        case 'id_vei_modelo':
          if (this.$store.state.flagBuscaVei === true) {
            retorno.where = { m: 'veiculo', f: 'ref_modelo', o: 'in', v: where.v.join() }
          } else {
            retorno.where = { m: 'veiculo', f: 'id_mod', o: 'in', v: where.v.join() }
          }
          break

        case 'id_vei_marca':
          if (this.$store.state.flagBuscaVei === true) {
            retorno.where = { m: 'veiculo', f: 'ref_modelo', o: 'in', r: 'id', q: {
              model: 'vei_modelo',
              where: { f: 'id_marca', o: '=', v: where.v.join() }
            } }
          } else {
            retorno.where = { m: 'veiculo', f: 'id_mar', o: 'in', v: where.v.join() }
          }
          break
      }

      // RETORNA O VALOR MONTADO
      return retorno
    },
    vendaRelatorioUltimaVenTabSetarLinhas: function (vetor) {
      // INICIA AS CHAVES QUE DEVE VERIFICAR
      var chaves = [ 'virtual_id_con_qtde_pet', 'virtual_id_con_qtde_veiculo', 'virtual_id_con_qtde_venda', 'virtual_id_con_qtde_orcamento', 'virtual_id_con_financeiro_aberto', 'virtual_id_con_financeiro_atraso', 'virtual_id_con_total_orcamento_produto', 'virtual_id_con_total_orcamento_servico', 'virtual_id_con_total_orcamento', 'virtual_id_con_total_venda_produto', 'virtual_id_con_total_venda_servico', 'virtual_id_con_total_venda', 'virtual_id_con_ticket_medio_venda' ]

      // SETA OS IDS SOLICITADOS
      for (var indexL in vetor) {
        // SETA O BOTÃO PARA OS DADOS DA VENDA
        vetor[indexL].link_cadastro_con = {
          status: '',
          class: [ 'btn', 'btn-default', 'bt-link-cadastro' ],
          mostrar: true
        }

        // MONTA O TEMPO DA ULTIMA VENDA
        vetor[indexL].ultima_venda_tempo = this.vendaRelatorioUltimaVenTabFormatarUltimaData(vetor[indexL])

        // VERIFICA SE EXISTE ALGUMA COISA PARA O CAMPO
        for (var indexC in chaves) {
          if ([ '', null, undefined, '0,00' ].indexOf(vetor[indexL][chaves[indexC]]) !== -1) {
            vetor[indexL][chaves[indexC]] = '---'
          }
        }
      }

      // SETA OS VALORES RECEBIDOS
      this.linha = vetor

      // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
      this.time = new Date().getTime()
    },
    vendaRelatorioUltimaVenTabFormatarUltimaData: function (vetor) {
      // INICIA A VARIAVEL PARA RETORNO
      var retorno = '---'

      // VERIFICA SE TEM VALOR RECEBIDO
      if ([ '', null, undefined ].indexOf(vetor) === -1) {
        // TRANSFORMA A DATA E MOMENT.JS
        vetor._data = moment(vetor.vencimento_max_ptbr, 'DD/MM/YYYY')

        // CALCULA A DIFERENÇA DAS DATAS
        vetor.diff = moment.duration(moment(this.$store.state.dadosApi.datetime, 'YYYY-MM-DD HH:mm:ss').diff(vetor._data))

        // PEGA O NUMERO DE DIAS
        var days = parseInt(vetor.diff.asDays())

        // PEGA O NUMERO DE HORAS
        var hours = parseInt(vetor.diff.asHours())

        // CALCULA A QUANTIDADE DE HORAS
        hours = hours - days*24

        // PEGA O NUMERO DE MINUTOS
        var minutes = parseInt(vetor.diff.asMinutes())

        // CALCULA A QUANTIDADE DE MINUTOS
        minutes = minutes - (days*24*60 + hours*60)

        // LIMPA A VARIAVEL
        retorno  = ''
        if (days > 0 || hours > 0 || minutes > 0) {
          retorno += 'Hà '
          if (days > 366) {
            retorno += Math.trunc(days / 365) + ' ano' + (days >= 2 ? 's' : '')
          } else if (days > 0) {
            retorno += days + ' dia' + (days >= 2 ? 's' : '')
          } else if (hours > 0) {
            retorno += hours + ' hora' + (hours >= 2 ? 's' : '')
          } else if (minutes > 0) {
            retorno += minutes + ' minuto' + (minutes >= 2 ? 's' : '')
          }
        }
      }

      // RETORNA O VALOR MONTADO
      return retorno
    },
    vendaRelatorioUltimaVenTabOnClick: function (indexCV, linha) {
      if ([ '', null, undefined, '---' ].indexOf(linha[indexCV]) === -1) {
        this.cpntMontarFiltros((filtros) => {
          if (filtros !== 'ERRO_FILTRO') {
            // INICIA A VARIAVEL ROTA
            var route = ''
            
            // INICIA OS PARAMETROS QUE SERÁ UTILIZADO
            var params = { cts: this.$store.state.token.cts }

            // SETA OS FILTROS INICIAIS
            params.busca = filtros
    
            // FAZ UM SWITCH PARA VERIFICA A AÇÃO
            switch (indexCV) {
              case 'virtual_id_con_qtde_venda':
              case 'virtual_id_con_qtde_orcamento':
                // SETA O NOME DA ROTA WEB QUE DEVE ABRIR
                route = 'venda_busc'

                // SETA OS PARAMETROS DA BUSCA
                params.busca = params.busca.concat([
                  { f: 'status',        o: '=', v: (indexCV === 'virtual_id_con_qtde_venda' ? 'demanda' : 'orcamento') },
                  { f: 'id_con_nome',   o: '=', v: linha.id_con }
                ])
                break
    
              case 'vencimento_max_ptbr':
                // SETA O NOME DA ROTA WEB QUE DEVE ABRIR
                route = 'venda_busc'

                // SETA OS PARAMETROS DA BUSCA
                params.busca = params.busca.concat([
                  { f: 'codigo', o: '=', v: linha.cod_venda_max }
                ])
                break

              case 'virtual_id_con_qtde_veiculo':
                // SETA O NOME DA ROTA WEB QUE DEVE ABRIR
                route = 'veiculo_busc'

                // SETA OS PARAMETROS DA BUSCA
                params.busca = { tipo: 'con', id: linha.id_con }
                break

              case 'virtual_id_con_qtde_pet':
                // SETA O NOME DA ROTA WEB QUE DEVE ABRIR
                route = 'pet_busc'

                // SETA OS PARAMETROS DA BUSCA
                params.busca = { tipo: 'con', id: linha.id_con }
                break

              case 'virtual_id_con_financeiro_aberto':
              case 'virtual_id_con_financeiro_atraso':
                // SETA O NOME DA ROTA WEB QUE DEVE ABRIR
                route = 'financeiro_relatorio_params'

                // SETA OS PARAMETROS DA BUSCA
                params.params = {
                  pesquisa: '0',
                  despesa: [ 'n' ],
                  contato: [ linha.id_con ],
                  status: [ '1', '4' ],
                  periodo: 't'
                }

                // SETA O PERIODO PARA BUSCA DE DEBITOS EM ABERTO
                if (indexCV === 'virtual_id_con_financeiro_atraso') {
                  params.params.periodo = '4'
                  params.params.periodo_ini = '01/01/1900'
                  params.params.periodo_fim = this.$store.state.dadosApi.dataOntem
                }
                break

              case 'id_con':
                // SETA OS PARAMETROS QUE SERÁ ENVIADO
                params = { editar: false, tipo: 'contato', id: linha.id_con }

                // SETA O CALLBACK QUE DEVE EXECUTAR
                params.callback = (atualizar) => {
                  if (atualizar === true) {
                    this.vendaRelatorioUltimaVenTabBuscarLinhas()
                  }
                }

                // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
                this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
                break
            }

            // VERIFICA SE FOI ENCONTRADO UMA ROTA PARA SER CHAMADA
            if (route !== '') {
              // CONVERTE A VARIAVEL EM B64
              if ([ '', null, undefined ].indexOf(params.busca) === -1) {
                params.busca = window.btoa(JSON.stringify(params.busca))
              }
              if ([ '', null, undefined ].indexOf(params.params) === -1) {
                params.params = window.btoa(JSON.stringify(params.params))
              }
      
              // ABRE A PAGINA SOLICITADA
              this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: route, params: params }).href, '_blank')
            }
          }
        })
      }
    }
  }
}
</script>
